<cap-input
  [type]="to.type || 'text'"
  [class]="to.styleClass"
  [placeholder]="(to.translatePlaceholder || to.placeholder) | observablePipe | async"
  [formlyAttributes]="field"
  [autocomplete]="to.autocomplete || 'off'"
  [formControl]="formControl"
  [class.ng-dirty]="showError"
></cap-input>
